import Swal from "sweetalert2";

const SWAL_BASE = {
  buttonsStyling: false,
  customClass: {
    popup: "bw-swal",
    title: "bw-swal-title",
    htmlContainer: "bw-swal-text",
    actions: "bw-swal-actions",
    input: "form-control bw-swal-input",
    inputLabel: "form-label bw-swal-label",
  },
  showCancelButton: true,
  cancelButtonText: "Cancel",
  reverseButtons: true,
};

const CONFIRM_BTN = {
  primary: "btn btn-primary",
  success: "btn btn-primary",
  danger: "btn btn-danger",
};

export function confirmAction({
  title,
  text,
  icon = "question",
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "primary",
} = {}) {
  return Swal.fire({
    ...SWAL_BASE,
    title,
    text,
    icon,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    customClass: {
      ...SWAL_BASE.customClass,
      confirmButton: CONFIRM_BTN[variant] || CONFIRM_BTN.primary,
      cancelButton: "btn btn-outline-secondary",
    },
  });
}

export function promptAction({
  title,
  text,
  input = "textarea",
  inputLabel,
  inputPlaceholder,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "danger",
} = {}) {
  return Swal.fire({
    ...SWAL_BASE,
    title,
    text,
    input,
    inputLabel,
    inputPlaceholder,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    customClass: {
      ...SWAL_BASE.customClass,
      confirmButton: CONFIRM_BTN[variant] || CONFIRM_BTN.danger,
      cancelButton: "btn btn-outline-secondary",
    },
  });
}
